<div style="margin-top: 20px"></div>


<div style="padding: 10px 10px;">
    <dx-toolbar style="padding-right: 30px;">
        <dxi-item name="groupPanel"></dxi-item>
        <dxi-item location="after">            
            <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel"
            (onClick)="exportExcel($event)" [disabled]="childDataGrids.length == 0">
            </dx-button>
        </dxi-item>
        <dxi-item name="searchPanel"></dxi-item>
    </dx-toolbar>

    <div style="margin-top: 10px"></div>
    
    <div>
        <dx-tab-panel
            #crmChildTabPanel
            [height]="'auto'"  
            [selectedIndex]="0"
            [loop]="false"
            [animationEnabled]="false"
            [swipeEnabled]="false"
            [deferRendering]="false"
            [visible]="true">
        
            <dxi-item [title]="'LB SAP'">
                <div class="heading-box">                    
                    <h4 class="heading">{{lbsap_heading1}}</h4>
                    <h4 class="heading">{{lbsap_heading2}}</h4>                    
                    <h6 style="margin-bottom: 10px;">{{lbsap_subheading1}}</h6>
                </div>
                <app-crm-report-datagrid 
                    [reportRequest]="reportRequest" 
                    [reportType]="'CurrCust_LBSAP'"
                    (dataGridCreated)="onDataGridCreated($event)">
                </app-crm-report-datagrid>  
            </dxi-item>
            <dxi-item [title]="'All SAP'">
                
                <div class="heading-box">
                    <h4 class="heading">{{allsap_heading1}}</h4>
                    <h4 class="heading">{{allsap_heading2}}</h4>
                    <h6 style="margin-bottom: 10px;">{{allsap_subheading1}}</h6>
                    <p style="margin-bottom: 5px;">The Dollars in the <b>All SAP Sales</b> may not exactly match <b>LB SAP Sales</b> because:</p>
                    <ul class="">
                        <li><b>LB SAP</b> page only adds sales where QtyUnit=’KG’</li>
                        <li><b>All SAP</b> page adds any QtyUnit, and there are gas sales dollars where QtyUnit=’KG’ and ‘EA’</li>
                    </ul>
                </div>
                
                <app-crm-report-datagrid
                    [reportRequest]="reportRequest" 
                    [reportType]="'CurrCust_ALLSAP'"
                    (dataGridCreated)="onDataGridCreated($event)">
                </app-crm-report-datagrid>  
            </dxi-item>
        
        </dx-tab-panel>
    </div>
</div>
